class FacetForm extends HTMLFormElement {
    constructor() {
        super(), this.dirty = !1, this.cachedMap = new Map, this.addEventListener("change", this.onFormChange), this.addEventListener("submit", this.onFormSubmit)
    }
    onFormChange() {
        this.dirty = !0, this.dispatchEvent(new Event("submit", {
            cancelable: !0
        }))
    }
    onFormSubmit(e) {
        if (e.preventDefault(), !this.dirty) return;
        const t = this.buildUrl().toString();
        this.renderSection(t, e)
    }
    buildUrl() {
        const e = new URLSearchParams(new FormData(this)),
            t = new URL(this.action);
        return t.search = "", e.forEach(((e, n) => t.searchParams.append(n, e))), ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((e => {
            "" === t.searchParams.get(e) && t.searchParams.delete(e)
        })), t.searchParams.set("section_id", theme.utils.sectionId(this)), t
    }
    updateURLHash(e) {
        const t = new URL(e);
        t.searchParams.delete("section_id"), history.replaceState({}, "", t.toString())
    }
    beforeRenderSection() {
        const e = document.getElementById("ProductGridContainer"),
            t = e.querySelectorAll(".product-card"),
            n = theme.config.motionReduced ? 0 : 50;
        Motion.timeline([
            [t, {
                y: n,
                opacity: 0,
                visibility: "hidden"
            }, {
                duration: .5,
                delay: theme.config.motionReduced ? 0 : Motion.stagger(.1)
            }],
            [e, {
                y: n,
                opacity: 0
            }, {
                duration: .5,
                easing: "linear"
            }]
        ]), setTimeout((() => {
            const e = document.querySelector(".collection");
            window.scrollTo({
                top: e.getBoundingClientRect().top + window.scrollY - (theme.config.isTouch || theme.config.mqlSmall ? 95 : 20),
                behavior: theme.config.motionReduced ? "auto" : "smooth"
            });
            const t = document.getElementById("FacetDrawer");
            t && t.classList.add("loading")
        }), 100)
    }
    afterRenderSection() {
        const e = document.getElementById("ProductGridContainer"),
            t = e.querySelectorAll(".product-card"),
            n = theme.config.motionReduced ? 0 : 50;
        Motion.timeline([
            [e, {
                y: [n, 0],
                opacity: [0, 1]
            }, {
                duration: .5,
                easing: "linear"
            }],
            [t, {
                y: [n, 0],
                opacity: [0, 1],
                visibility: ["hidden", "visible"]
            }, {
                duration: .5,
                delay: theme.config.motionReduced ? 0 : Motion.stagger(.1)
            }]
        ]);
        const i = document.getElementById("FacetDrawer");
        i && i.classList.remove("loading"), document.dispatchEvent(new CustomEvent("collection:reloaded"))
    }
    renderSection(e, t) {
        this.cachedMap.has(e) ? this.renderSectionFromCache(e, t) : this.renderSectionFromFetch(e, t), this.hasAttribute("data-history") && this.updateURLHash(e), this.dirty = !1
    }
    renderSectionFromFetch(e, t) {
        this.beforeRenderSection();
        const n = performance.now();
        fetch(e).then((e => e.text())).then((i => {
            const r = performance.now() - n;
            setTimeout((() => {
                this.renderFilters(i, t), this.renderFiltersActive(i), this.renderProductGridContainer(i), this.renderProductCount(i), this.renderSortBy(i), theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, {
                    responseText: i
                }), this.cachedMap.set(e, i), this.afterRenderSection()
            }), r > 500 ? 0 : 500)
        }))
    }
    renderSectionFromCache(e, t) {
        this.beforeRenderSection(), setTimeout((() => {
            const n = this.cachedMap.get(e);
            this.renderFilters(n, t), this.renderFiltersActive(n), this.renderProductGridContainer(n), this.renderProductCount(n), this.renderSortBy(n), theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, {
                responseText: n
            }), this.afterRenderSection()
        }), 500)
    }
    renderFilters(e, t) {
        const n = (new DOMParser).parseFromString(e, "text/html").querySelectorAll("#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter]");
        Array.from(n).filter((e => !(e => {
            const n = t ? t.target.closest("[data-filter]") : void 0;
            return !!n && e.dataset.index === n.dataset.index
        })(e))).forEach((e => {
            const t = document.querySelector(`[data-filter][data-index="${e.dataset.index}"]`);
            null !== t && ("DETAILS" === t.tagName ? t.querySelector("summary + *").innerHTML = e.querySelector("summary + *").innerHTML : t.innerHTML = e.innerHTML)
        }))
    }
    renderFiltersActive(e) {
        const t = "FacetFiltersActive";
        if (null === document.getElementById(t)) return;
        const n = (new DOMParser).parseFromString(e, "text/html");
        document.getElementById(t).innerHTML = n.getElementById(t).innerHTML
    }
    renderProductGridContainer(e) {
        const t = "ProductGridContainer";
        if (null === document.getElementById(t)) return;
        const n = (new DOMParser).parseFromString(e, "text/html");
        n.querySelector("motion-list").setAttribute("motion-reduced", ""), document.getElementById(t).innerHTML = n.getElementById(t).innerHTML
    }
    renderProductCount(e) {
        const t = "ProductCount";
        if (null === document.getElementById(t)) return;
        const n = (new DOMParser).parseFromString(e, "text/html");
        document.getElementById(t).innerHTML = n.getElementById(t).innerHTML
    }
    renderSortBy(e) {
        const t = "SortByContainer";
        if (null === document.getElementById(t)) return;
        const n = (new DOMParser).parseFromString(e, "text/html");
        document.getElementById(t).innerHTML = n.getElementById(t).innerHTML
    }
}
customElements.define("facet-form", FacetForm, {
    extends: "form"
});
class FacetCount extends HTMLElement {
    constructor() {
        super()
    }
    facetUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.facetUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, this.onFacetUpdate.bind(this))
    }
    disconnectedCallback() {
        this.facetUpdateUnsubscriber && this.facetUpdateUnsubscriber()
    }
    get itemCount() {
        return parseInt(this.innerText)
    }
    onFacetUpdate(e) {
        const t = (new DOMParser).parseFromString(e.responseText, "text/html").querySelector("facet-count");
        this.innerText = t.innerHTML, this.hidden = 0 === this.itemCount
    }
}
customElements.define("facet-count", FacetCount);
class FacetRemove extends MagnetLink {
    constructor() {
        super(), this.addEventListener("click", this.onClick)
    }
    onClick(e) {
        const t = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');
        if (t) {
            e.preventDefault();
            const n = new URL(this.href);
            n.searchParams.set("section_id", theme.utils.sectionId(t)), t.renderSection(n.toString(), e)
        }
    }
}
customElements.define("facet-remove", FacetRemove, {
    extends: "a"
});
class FacetSort extends HTMLElement {
    constructor() {
        super(), Motion.inView(this, this.init.bind(this), {
            margin: "200px 0px 200px 0px"
        }), this.addEventListener("change", this.onChange), this.button.addEventListener("click", this.show.bind(this)), this.close.addEventListener("click", this.hide.bind(this)), document.addEventListener("click", this.onWindowClick.bind(this))
    }
    get listbox() {
        return this.querySelector(".sort-listbox")
    }
    get selection() {
        return this.querySelector(".sort-selection")
    }
    get button() {
        return this.querySelector(".sort-by")
    }
    get close() {
        return this.querySelector(".sort-close")
    }
    init() {
        this.initButton(), this.style.setProperty("--facet-listbox-height", `${this.listbox.getBoundingClientRect().height}px`)
    }
    initButton() {
        const e = this.selection.innerText,
            t = theme.getElementWidth(this.selection, e);
        this.style.setProperty("--facet-button-width", `${t}px`)
    }
    onChange(e) {
        const t = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');
        if (t) {
            const n = new URL(window.location.href);
            n.searchParams.set("sort_by", e.target.value), n.searchParams.set("section_id", theme.utils.sectionId(t)), n.searchParams.delete("page"), t.renderSection(n.toString(), e)
        }
        this.selection.innerText = e.target.nextElementSibling.innerText, this.initButton(), this.hide()
    }
    show() {
        this.button.setAttribute("open", "")
    }
    hide(e = !0) {
        if (this.button.hasAttribute("open")) {
            const t = this.button.querySelector("[data-fill");
            Motion.animate(t, {
                y: ["0%", e ? "0%" : "-76%"]
            }, {
                duration: .6,
                delay: e ? 0 : .2
            }), setTimeout((() => {
                this.button.removeAttribute("open")
            }), 100)
        }
    }
    onWindowClick(e) {
        this.contains(e.target) || this.button.hasAttribute("open") && this.hide(!1)
    }
}
customElements.define("facet-sort", FacetSort);
class FacetSticky extends HTMLElement {
    constructor() {
        super(), new IntersectionObserver(this.handleIntersection.bind(this), {
            rootMargin: `-${screen.availHeight-100}px 0px ${screen.availHeight}px 0px`
        }).observe(document.querySelector(".collection-section"))
    }
    get button() {
        return this.querySelector(".button")
    }
    handleIntersection(e) {
        e[0].isIntersecting ? Motion.animate(this.button, {
            opacity: 1,
            visibility: "visible",
            transform: ["translateY(15px)", "translateY(0)"]
        }, {
            duration: 1,
            easing: [.16, 1, .3, 1]
        }) : Motion.animate(this.button, {
            opacity: 0,
            visibility: "hidden",
            transform: ["translateY(0)", "translateY(15px)"]
        }, {
            duration: 1,
            easing: [.16, 1, .3, 1]
        })
    }
}
customElements.define("facet-sticky", FacetSticky);
class PriceRange extends HTMLElement {
    constructor() {
        super(), this.rangeMin = this.querySelector('input[type="range"]:first-child'), this.rangeMax = this.querySelector('input[type="range"]:last-child'), this.inputMin = this.querySelector('input[name="filter.v.price.gte"]'), this.inputMax = this.querySelector('input[name="filter.v.price.lte"]'), this.inputMin.addEventListener("focus", this.inputMin.select), this.inputMax.addEventListener("focus", this.inputMax.select), this.inputMin.addEventListener("change", this.onInputMinChange.bind(this)), this.inputMax.addEventListener("change", this.onInputMaxChange.bind(this)), this.rangeMin.addEventListener("change", this.onRangeMinChange.bind(this)), this.rangeMax.addEventListener("change", this.onRangeMaxChange.bind(this)), this.rangeMin.addEventListener("input", this.onRangeMinInput.bind(this)), this.rangeMax.addEventListener("input", this.onRangeMaxInput.bind(this))
    }
    onInputMinChange(e) {
        e.preventDefault(), e.target.value = Math.max(Math.min(parseInt(e.target.value), parseInt(this.inputMax.value || e.target.max) - 1), e.target.min), this.rangeMin.value = e.target.value, this.rangeMin.parentElement.style.setProperty("--range-min", parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100 + "%")
    }
    onInputMaxChange(e) {
        e.preventDefault(), e.target.value = Math.min(Math.max(parseInt(e.target.value), parseInt(this.inputMin.value || e.target.min) + 1), e.target.max), this.rangeMax.value = e.target.value, this.rangeMax.parentElement.style.setProperty("--range-max", parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100 + "%")
    }
    onRangeMinChange(e) {
        e.stopPropagation(), this.inputMin.value = e.target.value, this.inputMin.dispatchEvent(new Event("change", {
            bubbles: !0
        }))
    }
    onRangeMaxChange(e) {
        e.stopPropagation(), this.inputMax.value = e.target.value, this.inputMax.dispatchEvent(new Event("change", {
            bubbles: !0
        }))
    }
    onRangeMinInput(e) {
        e.target.value = Math.min(parseInt(e.target.value), parseInt(this.inputMax.value || e.target.max) - 1), e.target.parentElement.style.setProperty("--range-min", parseInt(e.target.value) / parseInt(e.target.max) * 100 + "%"), this.inputMin.value = e.target.value
    }
    onRangeMaxInput(e) {
        e.target.value = Math.max(parseInt(e.target.value), parseInt(this.inputMin.value || e.target.min) + 1), e.target.parentElement.style.setProperty("--range-max", parseInt(e.target.value) / parseInt(e.target.max) * 100 + "%"), this.inputMax.value = e.target.value
    }
}
customElements.define("price-range", PriceRange);
class InfiniteButton extends HoverButton {
    constructor() {
        super(), this.onClickHandler = this.onClick.bind(this)
    }
    connectedCallback() {
        this.addEventListener("click", this.onClickHandler), "infinite" == this.getAttribute("mode") && Motion.inView(this, this.onClickHandler, {
            margin: "200px 0px 200px 0px"
        })
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.onClickHandler)
    }
    onClick() {
        if (this.hasAttribute("aria-busy")) return;
        this.enableLoading();
        const e = this.buildUrl().toString();
        fetch(e).then((e => e.text())).then((e => {
            this.renderPagination(e), this.renderProductGridContainer(e)
        }))
    }
    renderPagination(e) {
        const t = document.getElementById("ProductGridContainer");
        if (null === t) return;
        const n = (new DOMParser).parseFromString(e, "text/html"),
            i = t.querySelector(".pagination"),
            r = n.querySelector(".pagination");
        r ? i.innerHTML = r.innerHTML : i.remove()
    }
    renderProductGridContainer(e) {
        const t = document.getElementById("ProductGridContainer");
        if (null === t) return;
        const n = (new DOMParser).parseFromString(e, "text/html"),
            i = t.querySelector("motion-list"),
            r = n.querySelector("motion-list");
        r && i && (r.querySelectorAll(".card").forEach((e => {
            i.appendChild(e)
        })), i.reload())
    }
    buildUrl() {
        const e = new URL(this.getAttribute("action"));
        return e.searchParams.set("section_id", theme.utils.sectionId(this)), e
    }
    enableLoading() {
        this.classList.add("pointer-events-none"), this.setAttribute("aria-busy", "true")
    }
}
customElements.define("infinite-button", InfiniteButton, {
    extends: "button"
});